import {WebGLRenderTarget,type Camera,type Scene,type WebGLRenderer} from 'three';
import {compileObjectAsync} from './compileObjectAsync';

/** Prepare an orbit's unseen surfaces and the linear water-reflection variants.
 * Compiles in parallel on the GPU; never draws, moves the camera, or holds a
 * render target across an await. Wait for the main-view programs before
 * submitting reflection work so both batches don't compete during arrival.
 */
export async function warmSceneViews(renderer:WebGLRenderer,scene:Scene,camera:Camera,signal?:AbortSignal):Promise<void>{
 await compileObjectAsync(renderer,scene,camera,null,signal);
 if(signal?.aborted)return;
 const previous=renderer.getRenderTarget(),linear=new WebGLRenderTarget(1,1);
 let ready:Promise<Scene>;
 try{
  renderer.setRenderTarget(linear);
  ready=compileObjectAsync(renderer,scene,camera,null,signal);
 }finally{
  renderer.setRenderTarget(previous);
  linear.dispose();
 }
 await ready;
}
